import { api } from '@here/api'
import type { Pagination } from '../useChannel'

/**
 * Deletes a setup by its ID.
 * @param {string} id - The ID of the setup to delete.
 * @returns {Object|null} The deleted setup data, or null if deletion fails.
 */
export const getPaginatedChannelHistory = async (pagination: Pagination) => {
	const { message, direction } = pagination

	const ascending = direction === 'next'

	let query = api()
		.from('message')
		.select(
			`
			*,
			profile (
				username,
				last_seen (updated_at)
			),
      profile_private (
        role
      ),
			message_reaction (
				emoji,
				created_by,
				message_id
			)
		`,
		)
		.eq('channel_id', message.channel_id)
		.limit(20)
		.order('created_at', { ascending })

	if (direction === 'previous') {
		query = query.lt('created_at', message.created_at)
	} else {
		query = query.gt('created_at', message.created_at)
	}

	const { data, error } = await query

	if (error) {
		console.error(error)
		throw new Error(error.message)
	}

	// Reverse if it's previous, to maintain chronological order in UI
	return ascending ? data || [] : (data || []).reverse()
}
